import React, { useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import './ProductDetail.css';
import products, { teeSpecifications } from './products';
import PageNavigation from './PageNavigation';

function ProductDetail() {
    const { productId } = useParams();
    const [selectedColor, setSelectedColor] = useState('black');
    const [selectedSize, setSelectedSize] = useState('M');
    const [selectedModel, setSelectedModel] = useState('Freestyler');
    const [copyResult, setCopyResult] = useState(null);

    const product = products.find(item => String(item.id) === productId);
    if (!product) {
        return <div className="product-detail-page"><PageNavigation shop /><p className="product-title">Product not found.</p><Link to="/shop">Back to clothes</Link></div>;
    }

    const variant = product.variants?.find(item => item.name === selectedModel);
    const price = variant?.price || product.price;
    const model = variant?.name || product.type;
    const specifications = variant ? teeSpecifications[model] : null;
    const colors = ['black'];
    const sizes = ['S', 'M', 'L', 'XL'];


    const garment = product.variants ? 'tee' : 'hoodie';
    const orderMessage = `Ik zou graag deze ${garment} kopen: ${product.name} — ${model}, maat ${selectedSize}, ${selectedColor === 'black' ? 'zwart' : selectedColor} (${price}).\nhttps://www.rotb.club/product/${product.id}`;

    const copyOrderMessage = async () => {
        try {
            await navigator.clipboard.writeText(orderMessage);
            setCopyResult({ message: orderMessage, success: true });
        } catch {
            setCopyResult({ message: orderMessage, success: false });
        }
    };


    return (
        <div className="product-detail-page">
            <PageNavigation shop />
            {/* Video Background */}
            <div className="detail-video-container">
                <video
                    autoPlay
                    muted
                    loop
                    playsInline
                    className="detail-background-video"
                >
                    <source src="/rotb_big.mp4" type="video/mp4" />
                </video>
                <div className="detail-video-overlay"></div>
            </div>

            {/* Product Detail Container */}
            <div className="product-detail-container">
                <div className="product-detail-content">
                    {/* Product Image */}
                    <div className="product-image-section">
                        <div className="detail-product-image-container">
                            <img
                                src={product.image}
                                alt={product.name}
                                className="detail-product-image"
                            />
                        </div>
                    </div>

                    {/* Product Info */}
                    <div className="product-info-section">
                        <h1 className="product-title">{product.name}</h1>
                        <p className="product-type">{product.type}</p>
                        <p className="product-price">{price}</p>

                        {product.variants && (
                            <div className="selection-group">
                                <h3 className="selection-label">MODEL</h3>
                                <div className="model-options" aria-label="Choose your T-shirt model">
                                    {product.variants.map(item => (
                                        <button key={item.name} type="button"
                                            className={`model-option ${selectedModel === item.name ? 'selected' : ''}`}
                                            aria-pressed={selectedModel === item.name}
                                            onClick={() => setSelectedModel(item.name)}>
                                            <span className="model-option-heading"><span>{item.name}</span><span>{item.price}</span></span>
                                            <span className="model-option-spec">{teeSpecifications[item.name].gsm} GSM · {teeSpecifications[item.name].fit}</span>
                                        </button>
                                    ))}
                                </div>
                            </div>
                        )}

                        {specifications && (
                            <section className="tee-specifications" aria-label="Fabric and fit" aria-live="polite">
                                <h3 className="selection-label">HEAVYWEIGHT COTTON</h3>
                                <dl>
                                    <div><dt>Composition</dt><dd>{specifications.fabric}</dd></div>
                                    <div><dt>Fabric weight</dt><dd>{specifications.gsm} GSM</dd></div>
                                    <div><dt>Fit</dt><dd>{specifications.fit}</dd></div>
                                </dl>
                                <p>{specifications.finish}</p>
                            </section>
                        )}

                        {/* Color Selection */}
                        <div className="selection-group">
                            <h3 className="selection-label">COLOR</h3>
                            <div className="color-options">
                                {colors.map(color => (
                                    <button
                                        key={color}
                                        className={`color-option ${selectedColor === color ? 'selected' : ''}`}
                                        onClick={() => setSelectedColor(color)}
                                        style={{ backgroundColor: color }}
                                    >
                                        {color.toUpperCase()}
                                    </button>
                                ))}
                            </div>
                        </div>

                        {/* Size Selection */}
                        <div className="selection-group">
                            <h3 className="selection-label">SIZE</h3>
                            <div className="size-options">
                                {sizes.map(size => (
                                    <button
                                        key={size}
                                        className={`size-option ${selectedSize === size ? 'selected' : ''}`}
                                        onClick={() => setSelectedSize(size)}
                                    >
                                        {size}
                                    </button>
                                ))}
                            </div>
                        </div>

                        {/* Description */}
                        <div className="product-description">
                            <h3 className="description-label">DESCRIPTION</h3>
                            <p className="description-text">{product.description}</p>
                        </div>

                        <section className="instagram-order" aria-label="Order via Instagram">
                            <label className="selection-label" htmlFor="instagram-order-message">YOUR ORDER MESSAGE</label>
                            <textarea id="instagram-order-message" value={orderMessage} readOnly rows={5}
                                onFocus={event => event.target.select()} />
                            <button type="button" className="copy-order-btn" onClick={copyOrderMessage}>COPY MESSAGE</button>
                            <p className="order-copy-status" role="status">
                                {copyResult?.message === orderMessage
                                    ? copyResult.success ? 'Message copied. Paste it into the Instagram chat and send.' : 'Copy the message above manually, then paste it into Instagram.'
                                    : 'Open the chat with @rotb.club, paste this message and send it to order.'}
                            </p>
                            <a className="add-to-cart-btn instagram-order-link" href="https://ig.me/m/rotb.club"
                                target="_blank" rel="noopener noreferrer" onClick={copyOrderMessage}>
                                ORDER VIA INSTAGRAM — {price}
                            </a>
                            <p className="instagram-order-note">Opening Instagram also copies your message. Nothing is sent automatically.</p>
                            <a className="instagram-profile-link" href="https://www.instagram.com/rotb.club/" target="_blank" rel="noopener noreferrer">Chat not opening? Visit @rotb.club →</a>
                        </section>
                    </div>
                </div>
            </div>


        </div>
    );
}

export default ProductDetail;
